import { AlertNotReleased } from "@/shared/components/alerts/alert-not-released";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { Outlet } from "react-router";

export default function ConfirmationsRoute() {
  const isReleased = useBooleanFlagValue("gsm.htz.confirmations", true);
  if (!isReleased) {
    return <AlertNotReleased />;
  }

  return <Outlet />;
}
